import script from "./ListProductVariantsOfPropertyValue.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListProductVariantsOfPropertyValue.vue?vue&type=script&setup=true&lang=ts"

import "./ListProductVariantsOfPropertyValue.vue?vue&type=style&index=0&id=74bcd2cc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74bcd2cc"]])

export default __exports__